import { CSSProperties } from 'react';
import { Color, Size, Styles } from '@vivli/shared/theme';

export const defaultTabContainerStyle: CSSProperties = {
    ...Styles.NO_SELECT,
    marginBottom: 0,
    width: '100%',
    height: '53px',
    alignItems: 'left',
    paddingLeft: Size.PADDING,
    paddingTop: Size.PADDING,
    fontSize: 19,
    color: Color.VIVLI_LIGHT_BLUE,
    backgroundColor: Color.WHITE,
    pointerEvents: 'inherit',
    position: 'relative'
};

export const topBlueTabContainerStyle: CSSProperties = {
    ...defaultTabContainerStyle,
    height: Size.HEADER_HEIGHT,
    display: 'flex',
    paddingLeft: Size.PADDING,
    paddingRight: Size.PADDING,
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: Color.WHITE,
    backgroundColor: Color.VIVLI_DARK_BLUE,
    textTransform: 'uppercase',
    alignItems: 'center',
    marginLeft: 'auto'
};
